import type { FaireProductEntity } from "../../entity_types/product";

export const p_r5s3xfph6p: FaireProductEntity = {
  token: "p_r5s3xfph6p",
  type: "product",
  name: "Cute Dinosaur Plush",
  brandToken: "b_qrthtbpuwu",
  brandName: "Funkyrel® Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/2d29c10a9ade12cfab14567c7de19ade7d478d7dcc320004b14cbe0118b5aa7d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/137af83cbac573d8516afba6d977bdcfd7cbc6f5692796293e0c365e703408b0.jpeg",
    "https://cdn.faire.com/fastly/44799a81347d7f3cd8059a8d2246ba89b01197aa1b030173f9a3a4ae4f4c6559.jpeg",
    "https://cdn.faire.com/fastly/967c999283a5ccf0c3245da81e9d5dbbbd040ca089053e7ca515ce584e9307b6.jpeg",
    "https://cdn.faire.com/fastly/fa4ea94b3f63e5a2322503cbc811e34c61b9a8ae28b4af89d4d784583ef81cf7.jpeg",
    "https://cdn.faire.com/fastly/b89e397efb8f5d2ac06e5de8bed3cf4ebdcefe5c76f71288c4846c5ebd017125.jpeg",
    "https://cdn.faire.com/fastly/5c7e28479d1f911074d784b54db688e37dd51e83fb58ba63f90cd2c517e53c7d.jpeg",
    "https://cdn.faire.com/fastly/68f4ba46997227f8c63976d385ee86148421a7c5216ac6f464938998752b8aec.jpeg",
    "https://cdn.faire.com/fastly/864d736f9d62bc28cb09fa97027b5d32e760f8b9d0acba407b39dfab436bb1bc.jpeg",
  ],
  priceDollars: 23.56,
  description:
    "Embrace the charm of our adorable Stuffed Animal Plush Toy! Made from premium materials, this huggable plush features a cute face and is machine washable. Perfect as a gift for friends on any occasion. Safety is guaranteed with no zippers and precise stitching. Enjoy cuddles with this irresistibly soft Dinosaur plush!\n\n Size\n BlueWhite 35cm / 14inch\n Blue 30cm / 12inch\n Others 40cm / 16inch\n\n Atzbranding is a new brand that has established itself in recent years. They are carried by over 200+ happy independent retailers all across the world! \n\n Our products come with UPC codes for inventory management and retail packaging so we can easily display them on shelves at stores, too!!\n\n We focus heavily upon cost efficiency while producing high-quality goods.If you have any questions about pricing or shipping feel free to message us through Faire (or email) - our team will do everything possible until this process goes as smoothly",
  tags: [],
  msrpDollars: 47.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:34.194Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
